module.exports = __webpack_public_path__ + "img/15.b2906f03.png";